<template>
  <AuthWrapper>
    <template v-slot:header>
      Reset Password
    </template>

    <template v-slot:main-action>
      <v-btn class="center-button" color="primary" type="submit" @click="updatePassword">Reset Password</v-btn>
    </template>

    <template v-slot:footer-link>
      <router-link to="/login" style="cursor:pointer;">
        Return to Login
      </router-link>
    </template>

    <template v-slot:default>
      <v-form ref="form" class="mx-2" v-model="valid" lazy-validation @keyup.native.enter="updatePassword">
        <v-text-field
          id="password"
          name="password"
          label="Enter new password"
          type="password"
          :rules="passwordRules"
          v-model="password"
        ></v-text-field>
        <v-text-field
          id="password-conf"
          name="password-conf"
          label="Re-enter new password"
          type="password"
          :rules="confirmPasswordRules.concat(passwordConfirmationRule)"
          v-model="confirmPassword"
        ></v-text-field>
      </v-form>
    </template>

  </AuthWrapper>
</template>

<script>
import {recaptcha} from "@/mixins/captcha";
import AuthWrapper from "@/layouts/auth/components/AuthWrapper";

export default {
  name: "ResetPassword",
  props: {
    resetKey: String
  },
  mixins: [recaptcha],
  components: {
    AuthWrapper
  },
  data: () => ({
    email: '',
    valid: null,
    emailRules: [
      v => !!v || 'E-mail is required',
      v => /^(([^<>()[\]\\.,;:\s@']+(\.[^<>()\\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'E-mail must be valid',
    ],
    password: '',
    passwordRules: [
      v => !!v || 'Password is required',
      v => /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,}/.test(v) || 'Password must contain at least lowercase letter, one number, a special character and one uppercase letter',
    ],
    confirmPassword: '',
    confirmPasswordRules: [v => !!v || "Password is required"]
  }),
  metaInfo () {
    return {
      title: "Reset Password"
    }
  },
  computed: {
    passwordConfirmationRule() {
      return () =>
        this.password === this.confirmPassword || "Password must match";
    }
  },
  methods: {
    async updatePassword() {
      const valid = this.$refs.form.validate();

      if (!valid) {
        const detail = "Please enter all fields required";
        await this.$store.dispatch("notification/triggerError", { detail });
        return;
      }

      await this.$store.dispatch("loader/loaderInitiate", { title: "Requesting password reset" });

      const captcha = await this.recaptchaToken();

      const result = await this.$store.dispatch("auth/passwordUpdate", { key: this.resetKey, pass: this.password, passConfirmation: this.confirmPassword, captcha: captcha });

      await this.$store.dispatch("loader/loaderCancel");

      if (result) {
        await this.$store.dispatch("notification/triggerSuccess", { detail: "Your password has been updated, you may now login" });
        await this.$router.push("/login");
      }
    }
  },
}
</script>

<style lang="scss" scoped>

</style>
